export default __webpack_public_path__ + "images/folha_de_redacao_Mindzup.pdf";